module.exports = __webpack_public_path__ + "static/media/gb8.6ea69409.png";